module.exports = __webpack_public_path__ + "assets/images/project/stylised-images/party-spp.jpg?v=e13e3f12";